// sin-actividad.component.ts
import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quiero-ayuden',
  templateUrl: './quiero-ayuden.component.html',
  styleUrls: ['./quiero-ayuden.component.scss']
})
export class QuieroAyudaComponent {
  @ViewChild('quieroAyudaModal', { static: false }) quieroAyudaModal!: ElementRef;

  constructor(private modalService: NgbModal,
              private tagM: TagManagerService
  ) {}

  ngOnInit(): void {
    this.tagM.logEvent(GoogleTagManager.eventPageView().solicitudExitosaLlamar());
  }


  goToPortal(): void {
    location.href = environment.redirections.portalPublico;
    this.tagM.logEvent(GoogleTagManager.eventInteracciones().solicitudExitosaLlamar().accionClick().setEtiqueta("entendido"))

  }

  goToAyuda(): void {
    location.href = environment.redirections.ayudatransbank;
  }

  abrirModal() {
    this.modalService.open(this.quieroAyudaModal, { centered: true, backdrop: 'static', keyboard: false });
  }
}